import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19fe23c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-px-md q-pb-md full-width row q-gutter-y-sm justify-center" }
const _hoisted_2 = { class: "flex items-center content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_radio = _resolveComponent("q-radio")!

  return (_openBlock(), _createElementBlock("div", {
    onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.goNextStep && _ctx.goNextStep(...args)), ["enter"])),
    id: "select-category"
  }, [
    _createVNode(_component_q_toolbar, _normalizeProps(_guardReactiveProps(_ctx.TEXT_QUATERNARY_TITLE)), {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.t(`LEAD_CREATION_STEPS.STEP-${_ctx.step}`)), 1)
      ]),
      _: 1
    }, 16),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assetCategoryOptions, (option) => {
        return (_openBlock(), _createBlock(_component_q_radio, {
          class: _normalizeClass([{ active: option.value === _ctx.assetCategory }, "iuf-radio"]),
          key: option.value,
          val: option.value,
          modelValue: _ctx.assetCategory,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.assetCategory) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createVNode(_component_q_icon, {
                    name: option.icon
                  }, null, 8, ["name"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t(option.label)), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _normalizeProps(_guardReactiveProps(_ctx.TEXT_SECONDARY_BODY)), _toDisplayString(option.description), 17)
                ])
              ])
            ])
          ]),
          _: 2
        }, 1032, ["class", "val", "modelValue"]))
      }), 128))
    ])
  ], 32))
}